import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_VIZSGALAT } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function ExaminationPage() {
  return (
    <>
      <Helmet>
        <title>Logopédiai Vizsgálat és Állapotfelmérés | Mosolytorna Dunakeszi</title>
        <meta name="description" content="Átfogó logopédiai állapotfelmérés és diagnosztika. A sikeres fejlesztés alapja a pontos vizsgálat és a személyre szabott terápiás terv kialakítása." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_VIZSGALAT} />
    </>
  );
}
